// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aan-navbar {
  padding: 12px 40px;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1000;
}

.aan-navbar-container {
  max-width: 1200px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.aan-navbar-logo img {
  height: 65px;
  object-fit: contain;
}

.aan-navbar-links {
  display: flex;
  gap: 25px;
  list-style: none;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  margin: 0;
  padding: 0;
}

.aan-navbar-links a {
  text-decoration: none;
  color: #222;
  transition: color 0.3s ease;
}

.aan-navbar-links a:hover {
  color: #c01313;
}

.aan-navbar-contact .aan-contact-button {
  background-color: #c01313;
  color: white;
  padding: 10px 24px;
  border-radius: 9999px;
  text-decoration: none;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.aan-navbar-contact .aan-contact-button:hover {
  background-color: #fe0000;
}

/* Responsive */
@media (max-width: 900px) {
  .aan-navbar-container {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .aan-navbar-links {
    flex-wrap: wrap;
    justify-content: center;
    gap: 18px;
    font-size: 15px;
  }

  .aan-contact-button {
    padding: 8px 20px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar/AANNavbar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;EACzC,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":[".aan-navbar {\n  padding: 12px 40px;\n  background-color: white;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  position: sticky;\n  top: 0;\n  width: 100%;\n  z-index: 1000;\n}\n\n.aan-navbar-container {\n  max-width: 1200px;\n  margin: auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.aan-navbar-logo img {\n  height: 65px;\n  object-fit: contain;\n}\n\n.aan-navbar-links {\n  display: flex;\n  gap: 25px;\n  list-style: none;\n  font-weight: 500;\n  font-family: \"Poppins\", sans-serif;\n  margin: 0;\n  padding: 0;\n}\n\n.aan-navbar-links a {\n  text-decoration: none;\n  color: #222;\n  transition: color 0.3s ease;\n}\n\n.aan-navbar-links a:hover {\n  color: #c01313;\n}\n\n.aan-navbar-contact .aan-contact-button {\n  background-color: #c01313;\n  color: white;\n  padding: 10px 24px;\n  border-radius: 9999px;\n  text-decoration: none;\n  font-weight: 600;\n  transition: background-color 0.3s ease;\n}\n\n.aan-navbar-contact .aan-contact-button:hover {\n  background-color: #fe0000;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .aan-navbar-container {\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n  }\n\n  .aan-navbar-links {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 18px;\n    font-size: 15px;\n  }\n\n  .aan-contact-button {\n    padding: 8px 20px;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
